// FlightCheck.js
import { connect } from 'react-redux';
import _ from 'lodash';
import getMeData from '../selector/getMeData.js';
import digestJwtToken from '../action/digestJwtToken.js';
import FlightCheck from '../component/FlightCheck.jsx';

const mapStateToProps = state => {
  return {
    token: getMeData(state, 'token'),
    meId: getMeData(state, 'id'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFlightCheck: _.debounce(async ({ token }) => {
      const fetchFlightCheck = (await import('../action/fetchFlightCheck.js'))
        .default;
      return dispatch(fetchFlightCheck({ token }));
    }, 2000),
    digestJwtToken: ({ token }) => dispatch(digestJwtToken({ token })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FlightCheck);
